export const HOME = '/'
export const PREVIEW = '/preview'
